import React, { useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import { Modal, Box, Backdrop, Fade, IconButton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import { HiArrowLeft, HiArrowRight } from "react-icons/hi";

import useStyles from "./styles";

interface Props {
  selectedUrl?: string;
  urls: (string | undefined)[];
  open: boolean;
  handleClose: () => void;
}

const ImageCarousel = (props: Props) => {
  const { open, urls, selectedUrl, handleClose } = props;
  const classes = useStyles();

  const [_selectedUrl, _setSelectedUrl] = useState<string>();

  useEffect(() => {
    if (selectedUrl) _setSelectedUrl(selectedUrl);
  }, [selectedUrl]);

  const renderSelectedImage = () => {
    if (_selectedUrl) return <img src={_selectedUrl} width="100%" height="100%" />;
  };

  const renderFooterStack = () => {
    return (
      <Stack spacing={1} direction="row">
        {urls.map((url) => (
          <div>
            <img src={url} className={classes.imageFooter} onClick={() => _setSelectedUrl(url)} />
          </div>
        ))}
      </Stack>
    );
  };

  const handleBackUrl = () => {
    const urlIndex = urls.findIndex((url) => url === _selectedUrl);
    if (urlIndex !== -1 && urlIndex - 1 >= 0) {
      _setSelectedUrl(urls[urlIndex - 1]);
    }
  };

  const handleNextUrl = () => {
    const urlIndex = urls.findIndex((url) => url === _selectedUrl);
    if (urlIndex !== -1 && urlIndex + 1 < urls.length) {
      _setSelectedUrl(urls[urlIndex + 1]);
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Stack direction="row" justifyContent="space-between">
          <IconButton className={classes.leftButton} onClick={handleBackUrl}>
            <HiArrowLeft />
          </IconButton>
          <IconButton className={classes.rightButton} onClick={handleNextUrl}>
            <HiArrowRight />
          </IconButton>
          <Box className={classes.box}>{renderSelectedImage()}</Box>
          <Box className={classes.footer}>{renderFooterStack()}</Box>
        </Stack>
      </Fade>
    </Modal>
  );
};

export default ImageCarousel;
